import { useState, useEffect } from 'react';

const API_URL = 'https://bot.devit.es/api';
const headers = () => ({
  'Content-Type': 'application/json',
  'Authorization': `Bearer ${localStorage.getItem('devit_token')}`
});

const CATEGORIAS = ['general', 'configuracion', 'whatsapp', 'facturacion', 'agente', 'otro'];
const PRIORIDADES = ['normal', 'alta', 'urgente'];

const ESTADO_BADGE = {
  abierto:    'badge-amber',
  en_proceso: 'badge-cyan',
  resuelto:   'badge-green',
  cerrado:    'badge-red',
};

export default function Soporte() {
  const [tickets, setTickets]       = useState([]);
  const [loading, setLoading]       = useState(true);
  const [vista, setVista]           = useState('lista');
  const [seleccionado, setSeleccionado] = useState(null);
  const [saving, setSaving]         = useState(false);
  const [msg, setMsg]               = useState('');

  const [form, setForm] = useState({
    asunto: '', descripcion: '', categoria: 'general', prioridad: 'normal'
  });

  const cargar = () => {
    fetch(`${API_URL}/tickets/`, { headers: headers() })
      .then(r => r.json())
      .then(data => { setTickets(Array.isArray(data) ? data : []); setLoading(false); });
  };

  useEffect(() => { cargar(); }, []);

  const enviar = async () => {
    if (!form.asunto || !form.descripcion) return;
    setSaving(true);
    const res = await fetch(`${API_URL}/tickets/`, {
      method: 'POST', headers: headers(),
      body: JSON.stringify(form)
    }).then(r => r.json());
    if (res.status === 'ok') {
      setMsg('✓ Ticket enviado correctamente');
      setForm({ asunto: '', descripcion: '', categoria: 'general', prioridad: 'normal' });
      cargar();
      setTimeout(() => { setMsg(''); setVista('lista'); }, 2000);
    }
    setSaving(false);
  };

  const formatFecha = (str) => {
    const d = new Date(str);
    return d.toLocaleDateString('es-ES', { day:'2-digit', month:'short', year:'numeric' });
  };

  return (
    <div>
      <div className="topbar">
        <div>
          <div className="page-title">Soporte</div>
          <div className="page-sub">Tickets de ayuda y consultas</div>
        </div>
        <div className="topbar-actions">
          {vista === 'lista' && (
            <button className="btn btn-primary" style={{fontSize:'12px',padding:'8px 16px'}}
              onClick={() => setVista('nuevo')}>
              + Nuevo ticket
            </button>
          )}
          {vista !== 'lista' && (
            <button className="btn btn-ghost" style={{fontSize:'12px',padding:'8px 16px'}}
              onClick={() => { setVista('lista'); setSeleccionado(null); }}>
              ← Volver
            </button>
          )}
        </div>
      </div>

      <div className="content">

        {/* NUEVO TICKET */}
        {vista === 'nuevo' && (
          <div className="card">
            <div className="card-title">Nuevo ticket de soporte</div>
            <div className="form-group">
              <label className="form-label">Asunto</label>
              <input className="form-input" placeholder="Describe brevemente tu problema"
                value={form.asunto} onChange={e => setForm({...form, asunto: e.target.value})}/>
            </div>
            <div className="form-row">
              <div className="form-group">
                <label className="form-label">Categoría</label>
                <select className="form-input" value={form.categoria}
                  onChange={e => setForm({...form, categoria: e.target.value})}>
                  {CATEGORIAS.map(c => <option key={c} value={c}>{c}</option>)}
                </select>
              </div>
              <div className="form-group">
                <label className="form-label">Prioridad</label>
                <select className="form-input" value={form.prioridad}
                  onChange={e => setForm({...form, prioridad: e.target.value})}>
                  {PRIORIDADES.map(p => <option key={p} value={p}>{p}</option>)}
                </select>
              </div>
            </div>
            <div className="form-group">
              <label className="form-label">Descripción</label>
              <textarea className="form-input" rows="6" style={{resize:'vertical',lineHeight:'1.6'}}
                placeholder="Describe el problema con el mayor detalle posible..."
                value={form.descripcion}
                onChange={e => setForm({...form, descripcion: e.target.value})}/>
            </div>
            {msg && <div className="alert alert-success" style={{marginBottom:'12px'}}>{msg}</div>}
            <div style={{display:'flex',gap:'10px'}}>
              <button className="btn btn-primary" onClick={enviar} disabled={saving}>
                {saving ? 'Enviando...' : '→ Enviar ticket'}
              </button>
              <button className="btn btn-ghost" onClick={() => setVista('lista')}>Cancelar</button>
            </div>
          </div>
        )}

        {/* DETALLE TICKET */}
        {vista === 'detalle' && seleccionado && (
          <div>
            <div className="card" style={{marginBottom:'16px'}}>
              <div style={{display:'flex',justifyContent:'space-between',alignItems:'flex-start',marginBottom:'16px'}}>
                <div>
                  <div style={{fontSize:'18px',fontWeight:700,color:'var(--text)',marginBottom:'6px'}}>
                    {seleccionado.asunto}
                  </div>
                  <div style={{display:'flex',gap:'8px'}}>
                    <span className={`badge ${ESTADO_BADGE[seleccionado.estado] || 'badge-amber'}`}>
                      {seleccionado.estado}
                    </span>
                    <span className="badge badge-cyan">{seleccionado.categoria}</span>
                    <span className="badge badge-red">{seleccionado.prioridad}</span>
                  </div>
                </div>
                <div style={{fontSize:'11px',color:'var(--text3)',fontFamily:'var(--font-mono)'}}>
                  {formatFecha(seleccionado.creado_en)}
                </div>
              </div>
              <div className="card-title">Tu consulta</div>
              <div style={{fontSize:'13px',color:'var(--text2)',lineHeight:'1.7',whiteSpace:'pre-wrap',
                background:'var(--bg3)',padding:'14px',borderRadius:'8px'}}>
                {seleccionado.descripcion}
              </div>
            </div>

            {seleccionado.respuesta ? (
              <div className="card">
                <div className="card-title">Respuesta de Devit</div>
                <div style={{fontSize:'13px',color:'var(--text)',lineHeight:'1.7',whiteSpace:'pre-wrap',
                  background:'rgba(0,229,160,0.05)',border:'1px solid rgba(0,229,160,0.15)',
                  padding:'14px',borderRadius:'8px'}}>
                  {seleccionado.respuesta}
                </div>
              </div>
            ) : (
              <div className="card" style={{textAlign:'center',padding:'32px'}}>
                <div style={{fontSize:'24px',marginBottom:'12px'}}>⏳</div>
                <div style={{fontSize:'13px',color:'var(--text2)'}}>
                  Tu ticket está siendo revisado. Te responderemos pronto por aquí y por email.
                </div>
              </div>
            )}
          </div>
        )}

        {/* LISTA TICKETS */}
        {vista === 'lista' && (
          <div>
            {loading && <div style={{color:'var(--text3)',fontSize:'12px'}}>Cargando...</div>}
            {!loading && tickets.length === 0 && (
              <div className="card" style={{textAlign:'center',padding:'48px'}}>
                <div style={{fontSize:'32px',marginBottom:'16px'}}>🎫</div>
                <div style={{fontSize:'15px',fontWeight:700,marginBottom:'8px'}}>Sin tickets abiertos</div>
                <div style={{fontSize:'13px',color:'var(--text2)',marginBottom:'24px'}}>
                  ¿Tienes alguna duda o problema? Abre un ticket y te ayudamos.
                </div>
                <button className="btn btn-primary" onClick={() => setVista('nuevo')}>
                  + Abrir ticket
                </button>
              </div>
            )}
            {tickets.length > 0 && (
              <div className="card">
                <table className="tenants-table">
                  <thead>
                    <tr>
                      <th>Asunto</th>
                      <th>Categoría</th>
                      <th>Prioridad</th>
                      <th>Estado</th>
                      <th>Fecha</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    {tickets.map(t => (
                      <tr key={t.id}>
                        <td style={{color:'var(--text)',fontWeight:500}}>{t.asunto}</td>
                        <td><span className="badge badge-cyan">{t.categoria}</span></td>
                        <td><span className={`badge ${t.prioridad === 'urgente' ? 'badge-red' : t.prioridad === 'alta' ? 'badge-amber' : 'badge-green'}`}>{t.prioridad}</span></td>
                        <td><span className={`badge ${ESTADO_BADGE[t.estado] || 'badge-amber'}`}>{t.estado}</span></td>
                        <td style={{fontFamily:'var(--font-mono)',fontSize:'11px'}}>{formatFecha(t.creado_en)}</td>
                        <td>
                          <button className="btn btn-ghost" style={{fontSize:'11px',padding:'4px 10px'}}
                            onClick={() => { setSeleccionado(t); setVista('detalle'); }}>
                            Ver →
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
}